import { Table, Button, Modal, message, Tag, Space } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";
// ➤ FIXED IMPORTS (Removed 'coupons/')
import AddCouponForm from "../components/AddCouponForm"; 
import UpdateCouponForm from "../components/UpdateCouponForm"; 
import { BASE_URL } from "../constants/Constants";

const Coupon = () => {
  const userId = localStorage.getItem("userId");
  const [coupons, setCoupons] = useState([]);
  const [isAddCouponModalVisible, setIsAddCouponModalVisible] = useState(false);
  const [isEditCouponModalVisible, setIsEditCouponModalVisible] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/coupons`);
      setCoupons(response?.data || []);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  const showAddCouponModal = () => setIsAddCouponModalVisible(true);
  const hideAddCouponModal = () => setIsAddCouponModalVisible(false);

  const showEditCouponModal = (coupon) => {
    setSelectedCoupon(coupon);
    setIsEditCouponModalVisible(true);
  };

  const hideEditCouponModal = () => {
    setSelectedCoupon(null);
    setIsEditCouponModalVisible(false);
  };

  const handleUpdateCoupon = async (updatedCoupon, id) => {
    try {
      await axios.put(`${BASE_URL}/api/coupons/${id}`, updatedCoupon);
      message.success("Coupon updated successfully");
      hideEditCouponModal();
      fetchData();
    } catch (error) {
      console.error("Update failed:", error);
      message.error("Failed to update coupon");
    }
  };

  const handleDeleteCoupon = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/coupons/${id}`);
      message.success("Coupon deleted");
      fetchData();
    } catch (error) {
      console.error(error);
      message.error("Failed to delete");
    }
  };

  const showDeleteConfirm = (coupon) => {
    Modal.confirm({
      title: `Delete coupon "${coupon.couponName}"?`,
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      onOk() {
        handleDeleteCoupon(coupon.couponId);
      },
    });
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "couponName",
      key: "couponName",
      render: (text) => <strong style={{ letterSpacing: '1px' }}>{text}</strong>
    },
    {
      title: "Discount",
      key: "discount",
      render: (_, r) => (
        <Tag color={r.couponType === "%" ? "blue" : "green"}>
          {r.couponType === "%" ? `${r.couponValue}% Off` : `₹${r.couponValue} Flat`}
        </Tag>
      ),
    },
    {
        title: "Applies To",
        key: "scope",
        render: (_, r) => {
            let color = 'default';
            let text = 'ALL PRODUCTS';
            
            // Handle null/undefined scope gracefully
            const scope = r.scope || "ALL";
            
            if (scope === 'PRODUCT') {
                color = 'gold';
                text = `Product ID: ${r.productId}`;
            } else if (scope === 'CATEGORY') {
                color = 'purple';
                text = `Category ID: ${r.categoryId}`;
            }

            return <Tag color={color}>{text}</Tag>;
        }
    },
    {
        title: "Min Order",
        dataIndex: "minOrderAmount",
        render: (val) => val ? `₹${val}` : <span className="text-muted">-</span>
    },
    {
      title: "Status",
      dataIndex: "couponStatus",
      key: "couponStatus",
      render: (status) => (
        <Tag color={status === "active" ? "success" : "error"}>
          {status ? status.toUpperCase() : "UNKNOWN"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
            <Button 
                icon={<EditOutlined />} 
                onClick={() => showEditCouponModal(record)} 
                size="small"
            >
                Edit
            </Button>
            <Button 
                danger 
                icon={<DeleteOutlined />} 
                onClick={() => showDeleteConfirm(record)} 
                size="small"
            >
                Delete
            </Button>
        </Space>
      ),
    },
  ];

  return userId ? (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
        <h2>Coupon Management</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={showAddCouponModal}>
          Add New Coupon
        </Button>
      </div>

      <Table 
        dataSource={coupons} 
        columns={columns} 
        rowKey="couponId" 
        scroll={{ x: true }} 
        pagination={{ pageSize: 8 }}
      />

      <AddCouponForm
        visible={isAddCouponModalVisible}
        onClose={hideAddCouponModal}
        onSubmit={() => { fetchData(); setIsAddCouponModalVisible(false); }} 
      />

      <UpdateCouponForm
        visible={isEditCouponModalVisible}
        onClose={hideEditCouponModal}
        onSubmit={handleUpdateCoupon}
        initialValues={selectedCoupon}
      />
    </div>
  ) : (
    <div className="p-5 text-center">Please login to manage coupons.</div>
  );
};

export default Coupon;